import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../asset/Portfolio/Portfolio.module.scss";


import WhoWeAreImage from "../../asset/homefour/artwork/artwork1.webp";
import WhoWeAreImage2 from "../../asset/homefour/artwork/artwork2.webp";
import WhoWeAreImage3 from "../../asset/homefour/artwork/artwork3.webp";
import WhoWeAreImage4 from "../../asset/homefour/artwork/artwork4.webp";

import WhoWeAreImage5 from "../../asset/homefour/digitizing/digitizing1.webp"
import WhoWeAreImage6 from "../../asset/homefour/digitizing/digitizing2.webp"
import WhoWeAreImage7 from "../../asset/homefour/digitizing/digitizing3.webp"
import WhoWeAreImage8 from "../../asset/homefour/digitizing/digitizing4.webp"


import WhoWeAreImage9 from "../../asset/homefour/namedrop/namedrop1.webp"
import WhoWeAreImage10 from "../../asset/homefour/namedrop/namedrop2.webp"
import WhoWeAreImage11 from "../../asset/homefour/namedrop/namedrop3.webp"
import WhoWeAreImage12 from "../../asset/homefour/namedrop/namedrop4.webp"

import WhoWeAreImage13 from "../../asset/homefour/printdesign/printdesign1.webp";
import WhoWeAreImage14 from "../../asset/homefour/printdesign/printdesign2.webp";
import WhoWeAreImage15 from "../../asset/homefour/printdesign/printdesign3.webp";

const categories = ["All", "Artwork", "Digitizing", "Namedrop", "Print Design"];

const portfolioItems = [
  {
    id: 1,
    title: "Vector Conversions",
    category: "Artwork",
    image: WhoWeAreImage,
  },
  {
    id: 2,
    title: "Regular Embroidery",
    category: "Digitizing",
    image: WhoWeAreImage5,
  },
  {
    id: 3,
    title: "Replication",
    category: "Namedrop",
    image: WhoWeAreImage9,
  },
  {
    id: 4,
    title: "Catalogs",
    category: "Print Design",
    image: WhoWeAreImage13,
  },
  {
    id: 5,
    title: "Image Edit",
    category: "Artwork",
    image: WhoWeAreImage2,
  },
  {
    id: 6,
    title: "Puff & 3D Embroidery",
    category: "Digitizing",
    image: WhoWeAreImage6,
  },
  {
    id: 7,
    title: "Mockup",
    category: "Artwork",
    image: WhoWeAreImage3,
  },
  {
    id: 8,
    title: "Creative",
    category: "Artwork",
    image: WhoWeAreImage4,
  },
  {
    id: 9,
    title: "Applique",
    category: "Digitizing",
    image: WhoWeAreImage7,
  },
  {
    id: 10,
    title: "Patches & Badges",
    category: "Digitizing",
    image: WhoWeAreImage8,
  },
  {
    id: 11,
    title: "Mascots & Icons",
    category: "Namedrop",
    image: WhoWeAreImage10,
  },
  {
    id: 12,
    title: "Custom Design",
    category: "Namedrop",
    image: WhoWeAreImage11,
  },
  {
    id: 13,
    title: "Embroidery",
    category: "Namedrop",
    image: WhoWeAreImage12,
  },
  {
    id: 14,
    title: "Labels & Scaling",
    category: "Print Design",
    image: WhoWeAreImage14,
  },
  // {
  //   id: 15,
  //   title: "Brochure & Flyer",
  //   category: "Print Design",
  //   image: img6,
  // },
  {
    id: 16,
    title: "Separations",
    category: "Print Design",
    image: WhoWeAreImage15,
  },
];

const PortfolioHome = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const navigate = useNavigate();

  const filteredItems =
    activeCategory === "All"
      ? portfolioItems
      : portfolioItems.filter((item) => item.category === activeCategory);

  return (
    <div className={styles.portfolioSection}>
      {/* Tabs */}
      <div className={styles.tabs}>
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`${styles.tab} ${activeCategory === cat ? styles.activeTab : ""
              }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className={styles.grid}>
        {filteredItems.map((item) => (
          <div key={item.id} className={styles.card} onClick={() => navigate(`/portfolio/${item.id}`)}>
            <div className={styles.imageWrapper}>
              <img src={item.image} alt={item.title} />
              <div className={styles.overlay}>
                <div className={styles.textTop}>{item.title}</div>
                <div className={styles.textBottom}>{item.category}</div>
                <div className={styles.arrow}>→</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioHome;
